const toBool = (val: string | undefined): boolean | undefined =>
  val === 'true' ? true : val === 'false' ? false : undefined;

const config = {
  ENVIRONMENT: import.meta.env.VITE_ENVIRONMENT as string,
  TENANT_ID: import.meta.env.VITE_TENANT_ID as string,
  API_URL: import.meta.env.VITE_API_URL as string,
  PROTOCOL: import.meta.env.VITE_PROTOCOL as string,
  REFERRAL_REQUEST: toBool(import.meta.env.VITE_REFERRAL_REQUEST),
  CAREY_ENABLED: toBool(import.meta.env.VITE_CAREY_ENABLED),
  MATOMO_ENABLED: toBool(import.meta.env.VITE_MATOMO_ENABLED),
  GOOGLE_TAG_ID: import.meta.env.VITE_GOOGLE_TAG_ID as string | undefined,
  FACEBOOK_PIXEL: import.meta.env.VITE_FACEBOOK_PIXEL as string | undefined,
};

export default config;

export const {
  ENVIRONMENT,
  TENANT_ID,
  API_URL,
  PROTOCOL,
  REFERRAL_REQUEST,
  CAREY_ENABLED,
  MATOMO_ENABLED,
  GOOGLE_TAG_ID,
  FACEBOOK_PIXEL,
} = config;
